import React, { useState, useRef, useEffect } from 'react';

const ExpandableContent = ({ content }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [isProcessed, setIsProcessed] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      const hasOverflow = contentRef.current.scrollHeight > contentRef.current.clientHeight;
      setIsOverflowing(hasOverflow);
      setIsProcessed(true);
    }
  }, [content]);

  const toggleExpand = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsExpanded(!isExpanded);
  };

  const createMarkup = () => ({ __html: content });

  return (
    <div className="relative">
      <div
        ref={contentRef}
        className={`transition-all duration-300 ${!isExpanded && (isOverflowing || !isProcessed) ? 'line-clamp-3' : ''}`}
        dangerouslySetInnerHTML={createMarkup()}
      />
      {!isExpanded && (isOverflowing || !isProcessed) && (
        <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-[var(--background-color-card)] to-transparent pointer-events-none"></div>
      )}
      {(isOverflowing || isExpanded) && (
        <button
          onClick={toggleExpand}
          className="absolute -bottom-1 right-0 text-[var(--color-primary-accent)] bg-transparent !bg-transparent hover:bg-transparent !hover:bg-transparent transition-none p-1 min-w-[unset] min-h-[unset] outline-none focus:outline-none border-none"
          data-testid="expand-toggle"
          aria-label={isExpanded ? 'Show Less' : 'Show More'}
        >
          <span className="material-symbols-outlined text-2xl">
            {isExpanded ? 'expand_less' : 'expand_more'}
          </span>
        </button>
      )}
    </div>
  );
};

export default ExpandableContent;